/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_TYPE_OF_APPLICATION: {
    size: 10,
    offset: 0,
    where: [],
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.boilerplate.getTypeOfApplication',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_TYPE_OF_APPLICATION' },
      },
    },
    GET_TYPE_OF_APPLICATION: {
      invoke: {
        id: 'getTypeOfApplication',
        src: 'getTypeOfApplication',
        onDone: {
          target: 'RENDER_PAGE',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_PAGE_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_PAGE: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_TYPE_OF_APPLICATION',
        },
      },
    },
    RENDER_PAGE_ERROR: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_TYPE_OF_APPLICATION',
        },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
